import { useEffect, useRef } from 'react';

import { ReviewBarWrapper } from './style';

export const ReviewBar = (): JSX.Element => {
  const trustPrilotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.Trustpilot && trustPrilotRef.current) {
      window.Trustpilot.loadFromElement(trustPrilotRef.current, true);
    }
  }, []);

  return (
    <ReviewBarWrapper className="review-bar">
      <div className="footer-logos">
        <div
          ref={trustPrilotRef}
          className="trustpilot-widget"
          data-locale="de-DE"
          data-template-id="53aa8807dec7e10d38f59f32"
          data-businessunit-id="55fad20f0000ff0005836a15"
          data-style-height="84px"
          data-style-width="100%"
          data-theme="light"
        />
        <a
          href="https://www.tuev-saar.de/zertifikat/sc44211/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="tuv-logo"
            src="https://images.ctfassets.net/64q0dihi81ut/1km4jcm2396nzR2487J7Bz/29469db912e227b4fa8a8f7212f2158b/SC44211_Pru__fzeichen_McMakler_TU__V_gepru__ftes_Onlineportal_2020_zw.svg"
            alt=""
          />
        </a>
      </div>
    </ReviewBarWrapper>
  );
};
